import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variedades-categoria',
  templateUrl: './variedades-categoria.component.html',
  styleUrls: ['./variedades-categoria.component.css']
})
export class VariedadesCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
